<div class="relative flex h-full flex-col overflow-y-auto">
  <div class="h-full flex flex-col overflow-hidden divide-y divide-zinc-200 dark:divide-zinc-800">


    <!-- header -->
    <div class="shrink-0 px-2 py-2 drawer-header-primary">
      <div class="flex space-x-3 h-full items-center">
        <div class="min-w-0 flex-1 px-2">
          <p class="text-md font-semibold text-primary">
            AI Tour Guide
          </p>
          <p class="text-sm text-secondary">
            Ask how to do something and I'll show you.
          </p>
        </div>

        <div class="h-full flex flex-col justify-center items-end">

          <button type="button" (click)="close()" class="btn-fab-secondary text-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>

        </div>
      </div>
    </div>
    <!-- header - END -->

    <!-- main content -->
    <div
      class="relative h-full flex-1 flex-col items-center justify-start w-full overflow-hidden drawer-body-primary divide-y divide-zinc-200 dark:divide-zinc-800 p-2">
      <div #thread class="h-full overflow-y-auto scrollbar-transparent flex flex-col gap-y-2">

        @for (message of messages(); track message.id) {
        <div class="ai-sidebar__message" [class.ai-sidebar__message--user]="message.role === 'user'">
          @if (message.role === 'user') {
          <div class="ai-sidebar__bubble ai-sidebar__bubble--user bg-indigo-600 text-white dark:bg-indigo-500">
            {{ message.text }}
          </div>
          } @else {
          <div
            class="ai-sidebar__bubble bg-white text-gray-900 border border-gray-200 dark:bg-zinc-700 dark:text-zinc-50 dark:border-zinc-600">
            {{ message.text }}
          </div>
          }
        </div>
        } @empty {
        <div class="flex flex-col items-center justify-start p-2 w-full">
          <div class="mx-auto w-full max-w-7xl">
            <h2 class="text-xl font-semibold tracking-tight text-primary">How can I help?</h2>
            <dl class="mt-6 divide-y divide-zinc-200 dark:divide-zinc-800">

              <div class="py-4 first:pt-0 last:pb-0">
                <dt>
                  <button type="button" command="--toggle" commandfor="faq-0"
                    class="flex w-full items-start justify-between text-left text-primary">
                    <span class="text-base/7 font-semibold">How-To Guides</span>
                    <span class="ml-6 flex h-7 items-center">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon"
                        aria-hidden="true" class="size-6 in-aria-expanded:hidden">
                        <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon"
                        aria-hidden="true" class="size-6 not-in-aria-expanded:hidden">
                        <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                  </button>
                </dt>
                <el-disclosure id="faq-0" class="contents">
                  <p class="mt-1 text-sm text-primary">Select an item to start the guided walkthrough.</p>
                  <dd class="mt-2">
                    <ul class="flex flex-col gap-1" role="list">
                      @for (task of featuredTasks(); track task.id) {
                      <li class="w-full">
                        <button (click)="startFeaturedTask(task.id)" [disabled]="busy()" type="button"
                          class="w-full rounded-full bg-white px-4 py-1 inline-flex items-center justify-between text-xs font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">
                          {{ task.title }}

                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4">
                            <path d="m9 18 6-6-6-6" />
                          </svg>
                        </button>

                      </li>
                      } @empty {
                      <li>
                        <p class="text-sm text-secondary">No featured guides yet.</p>
                      </li>
                      }
                    </ul>
                  </dd>
                </el-disclosure>
              </div>

              <div class="py-4 first:pt-0 last:pb-0">
                <dt>
                  <button type="button" command="--toggle" commandfor="faq-1"
                    class="flex w-full items-start justify-between text-left text-primary">
                    <span class="text-base/7 font-semibold">General Questions</span>
                    <span class="ml-6 flex h-7 items-center">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon"
                        aria-hidden="true" class="size-6 in-aria-expanded:hidden">
                        <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon"
                        aria-hidden="true" class="size-6 not-in-aria-expanded:hidden">
                        <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                  </button>
                </dt>
                <el-disclosure id="faq-1" hidden class="contents">
                  <p class="mt-1 text-sm text-primary">Select a question to see the answer.</p>
                  <dd class="mt-2">
                    <ul class="flex flex-col gap-4" role="list">
                      @for (group of featuredFaqsByCategory(); track group.category) {
                      <li class="w-full">
                        <h3 class="mb-1 text-xs font-semibold uppercase tracking-wide text-secondary">
                          {{ group.category }}
                        </h3>
                        <ul class="flex flex-col gap-1" role="list">
                          @for (faq of group.faqs; track faq.id) {
                          <li class="w-full">
                            <button (click)="answerFeaturedFaq(faq.id)" [disabled]="busy()" type="button"
                              class="w-full rounded-full bg-white px-4 py-1 inline-flex items-center justify-between gap-2 text-left text-xs font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">
                              <p class="m-0 flex-1">{{ faq.question }}</p>

                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-4 shrink-0" aria-hidden="true">
                                <path d="m9 18 6-6-6-6" />
                              </svg>
                            </button>
                          </li>
                          }
                        </ul>
                      </li>
                      } @empty {
                      <li>
                        <p class="text-sm text-secondary">No general questions yet.</p>
                      </li>
                      }
                    </ul>
                  </dd>
                </el-disclosure>
              </div>

              <!-- <div class="py-4 first:pt-0 last:pb-0">
                <dt>
                  <button type="button" command="--toggle" commandfor="faq-2"
                    class="flex w-full items-start justify-between text-left text-primary">
                    <span class="text-base/7 font-semibold">Definitions</span>
                    <span class="ml-6 flex h-7 items-center">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon"
                        aria-hidden="true" class="size-6 in-aria-expanded:hidden">
                        <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon"
                        aria-hidden="true" class="size-6 not-in-aria-expanded:hidden">
                        <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                  </button>
                </dt>
                <el-disclosure id="faq-2" hidden class="contents">
                  <dd class="mt-2 pr-12">
                    <p class="text-base/7 text-secondary">You boil the hell out of it. Lorem ipsum
                      dolor sit amet consectetur adipisicing elit. Magnam aut tempora vitae odio inventore fuga
                      aliquam nostrum quod porro. Delectus quia facere id sequi expedita natus.</p>
                  </dd>
                </el-disclosure>
              </div> -->




            </dl>
          </div>

        </div>
        }

      </div>
    </div>
    <!-- main content - END -->

    <!-- Footer -->
    <div class="shrink-0 px-2 py-2 drawer-header-primary flex flex-col gap-y-1">
      <div class="w-full flex flex-row items-center justify-between">
        <p class="text-xs text-secondary">Try: "How do I create a brief?"</p>
        <button type="button" (click)="resetChat()"
          class="rounded-full inline-flex items-center gap-x-1.5 bg-white px-2.5 py-1 text-xs text-secondary shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">Reset
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-3">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
        </button>

      </div>

      <div class="flex flex-row items-end justify-between gap-x-2">
        <textarea [value]="draft()" (input)="onInput($event)" id="comment" name="comment" rows="2"
          placeholder="Ask a question..." (keyup.enter)="send()"
          class="block flex-1 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500"></textarea>
        <button type="button" [disabled]="!draft().trim() || busy()" (click)="send()"
          class="rounded-full bg-indigo-600 p-1.5 text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
            <path
              d="M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z" />
            <path d="M6 12h16" />
          </svg>
        </button>
      </div>
    </div>
    <!-- Footer - END -->
  </div>
</div>